import { render, staticRenderFns } from "./GLastStudentsEntryModal.vue?vue&type=template&id=4cd251cc&scoped=true&"
import script from "./GLastStudentsEntryModal.vue?vue&type=script&lang=ts&"
export * from "./GLastStudentsEntryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd251cc",
  null
  
)

export default component.exports